var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.062L0 1.062L1.062 0L5 3.938L8.938 0L10 1.062L5 6.062Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDownArrow);
export default __webpack_public_path__ + "static/media/ExpandDownArrow.3b258ea40a10d2f82dd7a918da3ac7a8.svg";
export { ForwardRef as ReactComponent };